document.addEventListener('DOMContentLoaded', () => {
	const vatExemptionUpload = document.querySelector(
		'#visitedu_vat_exemption_file_upload'
	);

	if (vatExemptionUpload) {
		vatExemptionUpload.addEventListener('change', async (event) => {
			const file = event.target.files[0];

			if (file) {
				const formData = new FormData();
				formData.append('visitedu_vat_exemption_file_upload', file);

				const response = await fetch(
					`${window.visiteduCheckout?.ajaxUrl || '/wp-admin/admin-ajax.php'}?action=vat_exemption_upload`,
					{
						method: 'POST',
						body: formData,
						headers: {
							'X-WP-Nonce': window.visiteduCheckout?.nonce || '',
						},
					}
				);

				const responseText = JSON.parse(await response.text());

				if (!responseText.success) {
					console.error(
						'File upload failed:',
						responseText.data || 'Unknown error'
					);

					return;
				}

				// Update the hidden input field with the file URL
				const vatExemptionFileInput = document.querySelector(
					'#visitedu_vat_exemption_file'
				);

				vatExemptionFileInput.value = responseText.data;

				console.log('File uploaded successfully:', responseText.data);

				// Update the checkout session
				document.body.dispatchEvent(new Event('update_checkout'));
			}
		});
	}
});
